import { render, staticRenderFns } from "./news-edit.vue?vue&type=template&id=5cbb2467&scoped=true&"
import script from "./news-edit.vue?vue&type=script&lang=js&"
export * from "./news-edit.vue?vue&type=script&lang=js&"
import style0 from "./news-edit.vue?vue&type=style&index=0&id=5cbb2467&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbb2467",
  null
  
)

export default component.exports